import Seo from "./Seo";
import { buildBookDescription, buildBookJsonLd, buildBookKeywords } from "../utils/bookSeo";

type BookSeoProps = {
  book: any;
  canonicalPath: string;
};

const BookSeo = ({ book, canonicalPath }: BookSeoProps) => {
  if (!book) return null;

  const title = book?.pageTitle || book?.ogTitle || (book?.name ? `${book.name} | Gita Seva` : "Gita Seva Book");
  const description = book?.pageDescription || book?.ogDescription || buildBookDescription(book);
  const keywords = buildBookKeywords(book);
  const image = book?.bookPath;
  const jsonLd = buildBookJsonLd(book, canonicalPath);

  return (
    <Seo
      title={title}
      description={description}
      keywords={keywords}
      path={canonicalPath}
      image={image}
      ogImageWidth={1200}
      ogImageHeight={630}
      ogType="book"
      robots="index,follow"
      jsonLd={jsonLd}
    />
  );
};

export default BookSeo;

